import React, { useEffect, useState, useRef } from "react";
import Header from "../components/ui/header";
import "../design/subscriptions.css";
import Checkout from "../components/ui/checkout";
import RemoveCounties from "../components/ui/removeCounties";
import Footer from "../components/ui/footer";

const Subscriptions = () => {
  const [availableCounties, setAvailableCounties] = useState([]);
  const [userSubscriptions, setUserSubscriptions] = useState([]);
  const token = localStorage.getItem("access_token");
  const [filters, setFilters] = useState({county: "", state: "", industry: ""});
  const [addSubscriptions, setAddSubscriptions] = useState([]);
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isMounted = useRef(true);

  const fetchCounties = async () => {
    try {
      const response = await fetch("https://api.deliquentauction.com/subscriptions/counties/", {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (isMounted.current) {
        setAvailableCounties(data);
      }
    } catch (error) {
      console.error("Failed to fetch counties:", error);
    }
  };

  const fetchUserSubscriptions = async () => {
    try {
      const response = await fetch("https://api.deliquentauction.com/subscriptions/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (isMounted.current) {
        setUserSubscriptions(data);
      }
    } catch (error) {
      console.error("Failed to fetch subscriptions:", error);
    } finally {
      if (isMounted.current) {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    isMounted.current = true; 
    if (token) {
      fetchCounties();
      fetchUserSubscriptions();
    }

    return () => {
      isMounted.current = false; 
    };
  }, [token]);

  const handleDeleteAllSubscriptions = async () => {
    try {
      const response = await fetch("https://api.deliquentauction.com/subscriptions/cancel-all/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete all subscriptions");
      }

      setUserSubscriptions([]);
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  const filteredCounties = availableCounties.filter((county) => {
    const matchesCounty = !filters.county || county.name === filters.county;
    const matchesState = !filters.state || county.state === filters.state;
    const matchesIndustry = !filters.industry || county.industry === filters.industry;
    return matchesCounty && matchesState && matchesIndustry;
  });
  
  const handleClearFilters = () => {
    setFilters({ county: "", state: "", industry: "" });
  };

  const handleRemoveCounties = async (countyIdsToRemove) => {
    try {
      const response = await fetch("https://api.deliquentauction.com/subscriptions/unsubscribe-many/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(countyIdsToRemove),
      });
  
      if (!response.ok) throw new Error("Failed to remove counties");
  
      await fetchUserSubscriptions(); 
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };
    
  return (
    <div className="subscriptions">
        <Header />

        <div className="subscription-body">

            <div className="county-list">

                <div className="county-list-header">
                    <h3>Available Subscriptions</h3>
                </div>

                 <div className="county-filters">
                  <select 
                    value={filters.county}
                    onChange={(e) => setFilters({ ...filters, county: e.target.value })}
                  >
                    <option value="">All Counties</option>
                    {[...new Set(filteredCounties.map((c) => c.name))].sort().map((name) => (
                      <option key={name} value={name}>
                        {name}
                      </option>
                    ))}
                  </select>

                  <select
                    value={filters.state}
                    onChange={(e) => setFilters({ ...filters, state: e.target.value })}
                  >
                    <option value="">All States</option>
                    {[...new Set(filteredCounties.map((c) => c.state))].sort().map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>

                  <select
                    value={filters.industry}
                    onChange={(e) => setFilters({ ...filters, industry: e.target.value })}
                  >
                    <option value="">All Industries</option>
                    {[...new Set(filteredCounties.map((c) => c.industry))].sort().map((industry) => (
                      <option key={industry} value={industry}>
                        {industry}
                      </option>
                    ))}
                  </select>

                  <button onClick={handleClearFilters} className="clear-filters-button">
                    Clear Filters
                  </button>
                </div>

                <div className="county-list-body">
                    {filteredCounties.length === 0 ? (
                        <p>No available counties to subscribe to.</p> 
                    ) : (
                      [...filteredCounties]
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((county) => (
                        <div key={county.id} className="county-card">
                          <div className="county-card-title">County</div>
                          <div className="county-card-title">State</div>
                          <div className="county-card-title">Distress List</div>
                          <div className="county-card-title">Leads</div>
                          <div className="county-card-title">Monthly Cost</div>
                        
                          <div className="county-card-value">{county.name}</div>
                          <div className="county-card-value">{county.state}</div>
                          <div className="county-card-value">{county.industry}</div>
                          <div className="county-card-value">{county.lead_count}</div>
                          <div className="county-card-value">
                            {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(county.price)}
                          </div>
                        </div>
                        
                        ))
                    )}
                </div>
            </div>
            <div className="right-side-stack">

              <div className="my-subscriptions">

                <div className="my-subscriptions-header">
                    <h3>My Subscriptions</h3>
                </div>
                <div className="subscription-actions">
                  {userSubscriptions.length === 0 ? (
                    <button onClick={() => setIsCheckoutOpen(true)}>
                      Create Subscription
                    </button>
                  ) : (
                    <>
                      <button onClick={() => setIsCheckoutOpen(true)}>
                        Add To Subscription
                      </button>
                      <button onClick={() => setIsRemoveModalOpen(true)}>
                        Remove From Subscription
                      </button>
                      <button
                        onClick={async () => {
                          const confirmed = window.confirm("Are you sure you want to delete all subscriptions?");
                          
                          if (confirmed) {
                            await handleDeleteAllSubscriptions();
                          }
                        }}
                      >
                        Delete All Subscriptions
                      </button>
                    </>
                  )}
                </div>

                  <div className="my-subscriptions-body">
                    {isLoading ? (
                      <p>Loading subscriptions...</p> 
                    ) : userSubscriptions.length === 0 ? (
                      <p>You are not subscribed to any counties yet.</p>
                    ) : (
                        userSubscriptions.filter(sub => sub.active).map((sub) => {
                          const county = availableCounties.find(c => c.id === sub.county_id);
                          if (!county) return null;
                          return (
                              <div key={sub.id} className="county-card">
                                <div className="county-card-title">County</div>
                                <div className="county-card-title">State</div>
                                <div className="county-card-title">Distress List</div>
                                <div className="county-card-title">Leads</div>
                                <div className="county-card-title">Monthly Cost</div>
                              
                                <div className="county-card-value">{county.name}</div>
                                <div className="county-card-value">{county.state}</div>
                                <div className="county-card-value">{county.industry}</div>
                                <div className="county-card-value">{county.lead_count}</div>
                                <div className="county-card-value">
                                  {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(county.price)}
                                </div>
                              </div>
                            );
                          })
                        )
                      }
                  </div>
              </div>
            </div>
        </div>
      <Checkout
        isOpen={isCheckoutOpen}
        onClose={() => {
          setIsCheckoutOpen(false);
          fetchUserSubscriptions();
          setAddSubscriptions([]);
        }}
        subscriptions={addSubscriptions}
        availableCounties={availableCounties}
        userSubscriptions={userSubscriptions}
      />
      <RemoveCounties
        isOpen={isRemoveModalOpen}
        onClose={() => setIsRemoveModalOpen(false)}
        userSubscriptions={userSubscriptions}
        availableCounties={availableCounties}
        onRemove={handleRemoveCounties}
      />
      <Footer />
    </div>
  );
};

export default Subscriptions;